export default "__VITE_ASSET__GFizLzzJ__"